// // src/pages/stats/PlatformsChart.tsx
// import React, { useRef } from "react";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";

// // Register chart components and the data labels plugin
// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

// // Define your formatNumber function
// export const formatNumber = (num: number | undefined): string => {
//   if (num === undefined || num === null || isNaN(num)) {
//     return '0'; 
//   }

//   if (num < 1000) {
//     return num.toString();
//   } else if (num < 1_000_000) {
//     return (num / 1_000).toFixed(0) + 'K';
//   } else {
//     return (num / 1_000_000).toFixed(0) + 'M';
//   }
// };

// interface PlatformStats {
//   platform: string;
//   totalRecords: number;
// }

// interface AgeGenderDistributionChartProps {
//   stats: PlatformStats[];
// }

// const PlatformsChart: React.FC<AgeGenderDistributionChartProps> = ({ stats }) => {
//   const chartRef = useRef(null);

//   const platforms = stats.map(stat => stat.platform);
//   const totalRecords = stats.map(stat => stat.totalRecords);

//   const data = {
//     labels: platforms, // Platform names
//     datasets: [
//       {
//         label: "Total Records",
//         data: totalRecords,
//         backgroundColor: (context: any) => {
//           const chart = context.chart;
//           const { ctx, chartArea } = chart;

//           if (!chartArea) {
//             return null; // Important for responsive charts
//           }

//           const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
//           gradient.addColorStop(0, "#0070f0"); // Start color
//           gradient.addColorStop(1, "#67abf9"); // End color

//           return gradient;
//         },
//       },
//     ],
//   };

//   const options = {
//     responsive: true,
//     plugins: {
//       legend: {
//         position: "top" as const,
//       },
//       title: {
//         display: true,
//         text: "Total Records per Platform",
//       },
//       datalabels: {
//         color: "black",
//         anchor: "end" as const,
//         align: "end" as const,
//         formatter: (value: number) => formatNumber(value), // Use formatNumber here
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         ticks: {
//           callback: (tickValue: string | number) => formatNumber(Number(tickValue)), // Format Y-axis ticks
//         },
//       },
//     },
//   };

//   return <Bar ref={chartRef} data={data} options={options} />;
// };

// export default PlatformsChart;



// // src/pages/stats/PlatformsChart.tsx
// import React, { useRef } from "react";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";

// // Register chart components and the data labels plugin
// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

// // Define your formatNumber function
// export const formatNumber = (num: number | undefined): string => {
//   if (num === undefined || num === null || isNaN(num)) {
//     return '0'; 
//   }

//   if (num < 1000) {
//     return num.toString();
//   } else if (num < 1_000_000) {
//     return (num / 1_000).toFixed(0) + 'K';
//   } else {
//     return (num / 1_000_000).toFixed(0) + 'M';
//   }
// };

// interface PlatformStats {
//   platform: string;
//   totalRecords: number;
// }

// interface AgeGenderDistributionChartProps {
//   stats: PlatformStats[];
// }

// const PlatformsChart: React.FC<AgeGenderDistributionChartProps> = ({ stats }) => {
//   const chartRef = useRef(null);

//   const platforms = stats.map(stat => stat.platform);
//   const totalRecords = stats.map(stat => stat.totalRecords);

//   const data = {
//     labels: platforms, // Platform names
//     datasets: [
//       {
//         label: "Total Records",
//         data: totalRecords,
//         backgroundColor: (context: any) => {
//           const chart = context.chart;
//           const { ctx, chartArea } = chart;

//           if (!chartArea) {
//             return null; // Important for responsive charts
//           }

//           const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
//           gradient.addColorStop(0, "#0070f0"); // Start color
//           gradient.addColorStop(1, "#67abf9"); // End color

//           return gradient;
//         },
//         barThickness: 40,
//       },
//     ],
//   };

//   const options = {
//     responsive: true,
//     plugins: {
//       legend: {
//         position: "top" as const,
//       },
//       title: {
//         display: true,
//         text: "Total Records per Platform",
//       },
//       datalabels: {
//         color: "black",
//         anchor: "end" as const,
//         align: "end" as const,
//         formatter: (value: number) => formatNumber(value), // Use formatNumber here
//       },
//     },
//     scales: {
//       x: {
//         ticks: {
//           autoSkip: false, // Show all ticks
//         },
//       },
//       y: {
//         beginAtZero: true,
//         ticks: {
//           callback: (tickValue: string | number) => formatNumber(Number(tickValue)), // Format Y-axis ticks
//         },
//       },
//     },
//   };

//   return <Bar ref={chartRef} data={data} options={options} />;
// };

// export default PlatformsChart;



// src/pages/stats/PlatformsChart.tsx
// import React, { useRef } from "react";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";

// // Register chart components and the data labels plugin
// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

// // Define your formatNumber function
// export const formatNumber = (num: number | undefined): string => {
//   if (num === undefined || num === null || isNaN(num)) {
//     return '0'; 
//   }

//   if (num < 1000) {
//     return num.toString();
//   } else if (num < 1_000_000) {
//     return (num / 1_000).toFixed(0) + 'K';
//   } else {
//     return (num / 1_000_000).toFixed(0) + 'M';
//   }
// };

// interface PlatformStats {
//   platform: string;
//   totalRecords: number;
// }

// interface AgeGenderDistributionChartProps {
//   stats: PlatformStats[];
// }

// const PlatformsChart: React.FC<AgeGenderDistributionChartProps> = ({ stats }) => {
//   const chartRef = useRef(null);

//   const platforms = stats.map(stat => stat.platform);
//   const totalRecords = stats.map(stat => stat.totalRecords);

//   const data = {
//     labels: platforms, // Platform names
//     datasets: [
//       {
//         label: "Total Records",
//         data: totalRecords,
//         backgroundColor: (context: any) => {
//           const chart = context.chart;
//           const { ctx, chartArea } = chart;

//           if (!chartArea) {
//             return null; // Important for responsive charts
//           }

//           const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
//           gradient.addColorStop(0, "#0070f0"); // Start color
//           gradient.addColorStop(1, "#67abf9"); // End color

//           return gradient;
//         },
//         barThickness: 40, // Set the bar thickness
//         categoryPercentage: 0.7, // Adjust this value to control the space between columns
//         barPercentage: 0.9, // Adjust this value to control the width of the bars
//       },
//     ],
//   };

//   const options = {
//     responsive: true,
//     plugins: {
//       legend: {
//         position: "top" as const,
//       },
//       title: {
//         display: true,
//         text: "Total Records per Platform",
//       },
//       datalabels: {
//         color: "black",
//         anchor: "end" as const,
//         align: "end" as const,
//         formatter: (value: number) => formatNumber(value), // Use formatNumber here
//       },
//     },
//     scales: {
//       x: {
//         ticks: {
//           autoSkip: false, // Show all ticks
//         },
//       },
//       y: {
//         beginAtZero: true,
//         ticks: {
//           callback: (tickValue: string | number) => formatNumber(Number(tickValue)), // Format Y-axis ticks
//         },
//       },
//     },
//   };

//   return <Bar ref={chartRef} data={data} options={options} />;
// };

// export default PlatformsChart;



import React, { useRef } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

// Register chart components and the data labels plugin
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

// Define your formatNumber function
// export const formatNumber = (num: number | undefined): string => {
//   if (num === undefined || num === null || isNaN(num)) {
//     return '0'; 
//   }

//   if (num < 1000) {
//     return num.toString();
//   } else if (num < 1_000_000) {
//     return (num / 1_000).toFixed(0) + 'K';
//   } else {
//     return (num / 1_000_000).toFixed(0) + 'M';
//   }
// };


export const formatNumber = (num: number | undefined): string => {
  if (num === undefined || num === null || isNaN(num)) {
    return '0'; // Handle undefined or invalid numbers
  }

  if (num < 1000) {
    return num.toString();
  } else if (num < 1_000_000) {
    return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K'; // Format as thousand
  } else {
    return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'; // Format as million
  }
};

interface PlatformStats {
  platform: string;
  totalRecords: number;
}

interface AgeGenderDistributionChartProps {
  stats: PlatformStats[] | null; // Allow null to handle cases where data isn't ready
}

const PlatformsChart: React.FC<AgeGenderDistributionChartProps> = ({ stats }) => {
  const chartRef = useRef(null);

  // Check if stats is available
  if (!stats) {
    return <p>Loading...</p>; // Render a loading state
  }

  const platforms = stats.map(stat => stat.platform);
  const totalRecords = stats.map(stat => stat.totalRecords);

  const data = {
    labels: platforms,
    datasets: [
      {
        label: "Total Records",
        data: totalRecords,
        backgroundColor: (context: any) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (!chartArea) {
            return null;
          }

          const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
          gradient.addColorStop(0, "#0070f0");
          gradient.addColorStop(1, "#67abf9");

          return gradient;
        },
        barThickness: 40,
        categoryPercentage: 0.7,
        barPercentage: 0.9,
        borderRadius: 4, // Makes the bar corners rounded
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top" as const,
      },
      title: {
        display: true,
        text: "Total Records per Platform",
      },
      datalabels: {
        color: "black",
        anchor: "end" as const,
        align: "end" as const,
        formatter: (value: number) => formatNumber(value),
      },
    },
    scales: {
      x: {
        ticks: {
          autoSkip: false,
        },
        grid: {
          display: false, // Disable the grid lines on the y-axis
        },
      },
      y: {
        display: false,
        beginAtZero: true,
        ticks: {
          callback: (tickValue: string | number) => formatNumber(Number(tickValue)),
        },
        grid: {
          display: false, // Disable the grid lines on the y-axis
        },
      },
    },
  };

  return <Bar ref={chartRef} data={data} options={options} />;
};

export default PlatformsChart;
